module.exports = __webpack_public_path__ + "static/media/step1img2.956694fb.jpg";